module.exports = __webpack_public_path__ + "media/images/emoticons/clear-0e6efa83c057569051e5027aecfba1e4.gif";